module.exports = __webpack_public_path__ + "static/media/popular-nuggets.927efe40.svg";